module.exports = __webpack_public_path__ + "static/media/res2.fa3556fc.jpg";